"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ow_1 = require("ow");

var LogFormat_1 = require("../format/LogFormat");

var FallbackLog_1 = require("../util/FallbackLog");

var LogLevel_1 = require("./LogLevel");

var LogMetadata_1 = require("./LogMetadata");

var PortableEnv_1 = require("./PortableEnv");

var StaticConfig_1 = require("./StaticConfig");

var LiveLogConfig =
/*#__PURE__*/
function () {
  function LiveLogConfig(levelEvaluationEnvNames, fallbackLog) {
    _classCallCheck(this, LiveLogConfig);

    this.levelEvaluationEnvNames = [];
    this.level = LogLevel_1.LogLevel.DEFAULT_LEVEL;
    this.format = LogFormat_1.LogFormat.DEFAULT_FORMAT;
    this.metadata = LogMetadata_1.LogMetadata.EMPTY_METADATA;
    this.nextReevaluateTimestampMs = 0;
    this.levelEvaluationEnvNames = levelEvaluationEnvNames;
    ow_1.default(this.levelEvaluationEnvNames, "levelEvaluationEnvNames", ow_1.default.array.ofType(ow_1.default.string));
    this.fallbackLog = fallbackLog;
    ow_1.default(this.fallbackLog, "fallbackLog", ow_1.default.function);
    this.evaluateIfRequired();
  }

  _createClass(LiveLogConfig, [{
    key: "setLevelEvaluationEnvNames",
    value: function setLevelEvaluationEnvNames(levelEvaluationEnvNames) {
      this.levelEvaluationEnvNames = levelEvaluationEnvNames;
      this.evaluateIfRequired();
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      return this.format;
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return this.metadata;
    }
  }, {
    key: "evaluateIfRequired",
    value: function evaluateIfRequired() {
      if (Date.now() < this.nextReevaluateTimestampMs) {
        return;
      }

      try {
        this.nextReevaluateTimestampMs = Date.now() + StaticConfig_1.StaticConfig.REEVALUATE_CONFIG_AFTER_MS;
        this.evaluate();
      } catch (error) {
        this.fallbackLog("Could not evaluate live log config: ".concat(error, ": ").concat(error.stack));
      }
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      this.format = this.evaluateFormat();
      this.level = this.evaluateLogLevel();
      this.metadata = this.evaluateMetadata();
    }
  }, {
    key: "evaluateFormat",
    value: function evaluateFormat() {
      var formatStr = PortableEnv_1.PortableEnv(StaticConfig_1.StaticConfig.LOG_FORMAT_ENV);

      if (formatStr) {
        return LogFormat_1.LogFormat.valueOf(formatStr);
      } else {
        return LogFormat_1.LogFormat.DEFAULT_FORMAT;
      }
    }
  }, {
    key: "evaluateLogLevel",
    value: function evaluateLogLevel() {
      var primaryLevelEvaluation = this.chooseMostVerboseLevel(this.getEnvValues(this.levelEvaluationEnvNames));

      if (primaryLevelEvaluation) {
        return primaryLevelEvaluation;
      }

      var leastLevelEvaluation = this.chooseMostVerboseLevel(this.getEnvValues([StaticConfig_1.StaticConfig.LEAST_LEVEL_ENV]));

      if (leastLevelEvaluation) {
        return leastLevelEvaluation;
      }

      return LogLevel_1.LogLevel.DEFAULT_LEVEL;
    }
  }, {
    key: "getEnvValues",
    value: function getEnvValues(envNames) {
      var envValuesOrUndefined = envNames.map(function (envName) {
        return PortableEnv_1.PortableEnv(envName);
      });
      return envValuesOrUndefined.filter(function (val) {
        return !!val;
      }).map(function (elem) {
        return elem || "unreachable";
      });
    }
  }, {
    key: "chooseMostVerboseLevel",
    value: function chooseMostVerboseLevel(levelList) {
      var definedLevels = levelList.map(function (level) {
        return LogLevel_1.LogLevel.valueOf(level);
      });

      if (definedLevels.length === 0) {
        return undefined;
      }

      var mostVerboseLevel = definedLevels.reduce(function (theMostVerboseLevel, currLevel) {
        return LogLevel_1.LogLevel.moreVerbose(theMostVerboseLevel, currLevel);
      });
      return mostVerboseLevel;
    }
  }, {
    key: "evaluateMetadata",
    value: function evaluateMetadata() {
      try {
        var metadataStr = PortableEnv_1.PortableEnv(StaticConfig_1.StaticConfig.LOG_METADATA_ENV);

        if (metadataStr) {
          return JSON.parse(metadataStr);
        }
      } catch (error) {
        FallbackLog_1.FallbackLog.log("Could not parse value of ".concat(StaticConfig_1.StaticConfig.LOG_METADATA_ENV, " env: ").concat(error));
      }

      return LogMetadata_1.LogMetadata.EMPTY_METADATA;
    }
  }]);

  return LiveLogConfig;
}();

exports.LiveLogConfig = LiveLogConfig;